import appInfo from '../app-info';
import { apiHelper, call_post_api } from './api_helper';
export async function dm_gioitinh_select_all() {
    return call_post_api(appInfo.api_url + '/dm_gioitinh/select_all');
};
export const gioiTinhApi = {
    SelectAll: () => apiHelper.get('gioi-tinh')
}